import {Link} from "react-router-dom";

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return(
    <footer className="revamp-footer">
        <div className="revamp-footer-widgets section-padding">            
            <div className="container">
                <div className="row justify-content-between">
                    {/* Brand & Newsletter */}
                    <div className="col-lg-4 col-md-6 col-12 mb-5 mb-lg-0">
                        <div className="revamp-footer-brand">
                            <a href="/" className="footer-logo">
                                <img src="assets/img/logowhite.png" alt="Abia Tech Hub Logo" />
                            </a>
                            <p className="mt-4 mb-4 text-secondary">
                                Empowering the next generation of tech leaders through innovation, education, and entrepreneurship.
                            </p>
                            <div className="revamp-newsletter-box">
                                <h5 className="mb-3">Subscribe to our newsletter</h5>
                                <form className="revamp-newsletter-form">
                                    <input type="email" placeholder="Email address" required />
                                    <button type="submit" className="theme-btn">
                                        <i className="fal fa-paper-plane"></i>
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div> 

                    {/* Quick Links */}
                    <div className="col-lg-2 col-md-6 col-12 mb-5 mb-lg-0">                        
                        <div className="revamp-footer-widget">
                            <h4 className="widget-title">Company</h4>
                            <ul className="footer-links">
                                <li><Link to="/about">About Us</Link></li>
                                <li><a href="https://cretehost.com/" target="_blank" rel="noreferrer">Web Hosting</a></li>
                                <li><Link to="/contact">Careers</Link></li>
                                <li><Link to="/refund_policy">Refund Policy</Link></li>
                                <li><a href="https://blog.abiatechhub.com/" target="_blank" rel="noreferrer">Blog</a></li>
                            </ul>
                        </div>
                    </div> 
                   
                    {/* Contact Info */}
                    <div className="col-lg-3 col-md-6 col-12 mb-5 mb-lg-0">                        
                        <div className="revamp-footer-widget">
                            <h4 className="widget-title">Contact</h4>
                            <ul className="footer-contact-list">
                                <li>
                                    <i className="fas fa-map-marker-alt icon"></i>
                                    <span>6 Warri street, Umuahia, Abia State</span>
                                </li>
                                <li>
                                    <a href="mailto:hello@abiatechhub.com">
                                        <i className="fas fa-envelope-open-text icon"></i>
                                        <span>hello@abiatechhub.com</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="tel:+2348052749600">
                                        <i className="fas fa-phone icon"></i>
                                        <span>+234 805 274 9600</span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div> 

                    {/* Socials */}
                    <div className="col-lg-3 col-md-6 col-12">
                        <div className="revamp-footer-widget">
                            <h4 className="widget-title">Follow Us</h4>
                            <p className="mb-4 text-secondary">Stay connected with our community.</p>
                            <div className="revamp-social-links"> 
                                <a href="https://www.twitter.com/abiatechhub/" target="_blank" rel="noreferrer" aria-label="Twitter">
                                    <i className="fab fa-twitter"></i>
                                </a>
                                <a href="https://www.instagram.com/abiatechhub/" target="_blank" rel="noreferrer" aria-label="Instagram">
                                    <i className="fab fa-instagram"></i>
                                </a>
                                <a href="https://web.facebook.com/AbiaTechHub/" target="_blank" rel="noreferrer" aria-label="Facebook">
                                    <i className="fab fa-facebook-square"></i>
                                </a>
                                <a href="https://www.linkedin.com/company/abiatechhub/" target="_blank" rel="noreferrer" aria-label="LinkedIn">
                                    <i className="fab fa-linkedin"></i>
                                </a>
                            </div> 
                        </div>
                    </div> 
                </div>
            </div>
        </div>

        {/* Copyright Bar */}
        <div className="revamp-copyright-bar">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-md-6 text-center text-md-start">
                        <p>&copy; {currentYear} Abia Tech Hub. All Rights Reserved.</p>
                    </div>
                    <div className="col-md-6 text-center text-md-end">
                        <div className="footer-legal-links">
                            <Link to="/privacy">Privacy Policy</Link>
                            <Link to="/terms">Terms of Service</Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </footer>
    )
}
export default Footer;
